module.exports = __webpack_public_path__ + "img/discount-tag.a1542736.svg";